var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChevronLeft = function SvgChevronLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6616 19.6559C11.4393 19.8744 11.1407 19.9979 10.829 20C10.5172 19.9979 10.2186 19.8744 9.99637 19.6559L1.14858 10.8108C0.928933 10.5894 0.805687 10.2901 0.805687 9.97824C0.805687 9.66635 0.928933 9.36708 1.14858 9.14564L9.99359 0.297857C10.2184 0.0980274 10.5112 -0.00834016 10.8118 0.000511228C11.1125 0.00936262 11.3985 0.132764 11.6112 0.345474C11.8239 0.558184 11.9473 0.844127 11.9561 1.14481C11.965 1.4455 11.8586 1.73821 11.6588 1.96306L3.64916 9.97824L11.6616 17.9907C11.8786 18.2135 12 18.5122 12 18.8233C12 19.1343 11.8786 19.433 11.6616 19.6559Z",
    fill: "#223856"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChevronLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron-left.21e5f398.svg";
export { ForwardRef as ReactComponent };